import { createSlice } from "@reduxjs/toolkit";
import { getProcessLogsByRequestId } from "./thunk";

export interface ProcessLog {
  logId: number;
  requestId: number;
  step: string;
  subject: string;
  logDetail: string;
  status: number; // 1=Success, 2=Failed, 3=Warning
  createdAt: string;
}

export interface ProcessLogsState {
  logs: ProcessLog[];
  loading: boolean;
  error: string | null;
}

const initialState: ProcessLogsState = {
  logs: [],
  loading: false,
  error: null,
};

const processLogsSlice = createSlice({
  name: "processLogs",
  initialState,
  reducers: {
    clearLogs: (state) => {
      state.logs = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProcessLogsByRequestId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProcessLogsByRequestId.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload;
      })
      .addCase(getProcessLogsByRequestId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearLogs } = processLogsSlice.actions;
export default processLogsSlice.reducer;
